module.exports = __webpack_public_path__ + "static/media/stay.b29786ee.svg";